// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GalleryTeaser_wrapper__AVJEY","mainImageButton":"GalleryTeaser_mainImageButton__r6bsH","mainImage":"GalleryTeaser_mainImage__LGTEy"};